// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaPropertyByName,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: ?Object) => {
  const typeSchema = findDependentAlertTypeSchema(schema, "X_SPELLS_IN_Y_PERIOD_TYPE");

  return {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      xSpellsInYPeriodType: {
        required: findSchemaRequired(typeSchema, "xSpellsInYPeriodType"),
        title: "X Spells In Y Period Type",
        properties: {
          spells: {
            type: "integer",
            title: "Spells",
          },
          durationType: findSchemaPropertyByName(
            typeSchema,
            "xSpellsInYPeriodType",
            "durationType",
          ),
          dayType: findSchemaPropertyByName(typeSchema, "xSpellsInYPeriodType", "dayType"),
          days: {
            type: "integer",
            title: "Days",
          },
          period: {
            type: "integer",
            title: "Period",
          },
          periodType: {
            title: "Period Type",
            type: "string",
            oneOf: [
              { title: "Days", const: "D" },
              { title: "Months", const: "M" },
              { title: "Weeks", const: "W" },
            ],
          },
        },
        type: "object",
      },
    },
    required: [...baseSchema.required, "xDayTypeOrZSpellsInYPeriodType"],
  };
};

export const uiSchema = (t: (s: string) => string) => baseUiSchema(t);

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
